import React, { useEffect, useState } from "react"
import { useHistory, useParams } from 'react-router-dom';
import { useOrganizations } from "./useOrganizations";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { JsonHubProtocol } from "@microsoft/signalr";

export interface Item {
    plants: any[]
    data: Daum[]
}
export interface Daum {
    id: string
    label: string
    sys_datemodified_utc_epoch: number
    monthkey: number
    ispremium_20251231?: number
    currency_20251231_iso4217?: number
    ispremium_20251230?: number
}
export const OrganizationsBilling = () => {
    const { id } = useParams();

    var nav = useHistory();
    const ui = useOrganizations();
    const org = ui.organizations?.[id];

    const [data, setdata] = useState<Item>(undefined)
    const load = async () => {
        if (!!org?.id) {
            const a: {
                item: Item
                success: boolean
                message: string
                statusCode: number
            } = await FetchHandler.getJson("/api/organization/" + org?.id + "/billing");
            setdata(a?.item);
        }
    }

    useEffect(() => {
        load();
    }, [, org?.id]);

    const getCurrency = (e: number) => {
        if (e === 752) {
            return "SEK";
        } else if (e === 578) {
            return "NOK";
        } else if (e === 978) {
            return "EUR";
        } else {
            return "SEK";
        }
    }


    return (
        <div className="screen-organizations">
            <h1>
                {org?.name}
            </h1>
            <div className="billing-months">
                {data?.data?.map(t => (
                    <div key={t?.monthkey} className="billing-month">
                        <h2>
                            Period:  {t?.monthkey}
                        </h2>
                        <div>
                            Valuta:  {getCurrency(t?.currency_20251231_iso4217)}
                        </div>
                        <div>
                            <DataElement item={data?.data?.find(m => m.monthkey === t?.monthkey)} />
                        </div>

                        <h3>
                            Växter
                        </h3>

                        <div>
                            Antal växtkort företaget legat på under månaden: <span className="num">{data?.plants?.find(m => m.monthkey === t?.monthkey)?.count ?? 0}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
type DType = {
    [x: string]: {
        dates: number[]
    }

}
const DataElement = ({ item }: { item: Daum }) => {

    const [offerData, setOfferData] = useState<DType>(undefined);
    const [premiumData, setPremiumData] = useState<DType>(undefined);

    const ss = () => {
        let offers: DType = {};
        let premium: DType = {};
        Object.keys(item ?? {}).forEach(key => {
            const e = key.split('_');
            const type = e?.[0];
            const dk = parseInt(e?.[1]);
            const oid: string = e?.[2];

            if (type?.startsWith("off")) {
                if (!!offers[oid]) {
                    offers[oid].dates.push(dk)
                } else {
                    offers[oid] = { dates: [dk] }
                }
            }
            if (type?.startsWith("ispremium")) {
                if (!!premium["premium"]) {
                    premium["premium"].dates.push(dk)
                } else {
                    premium["premium"] = { dates: [dk] }
                }
            }
        });
        setOfferData(offers);
        setPremiumData(premium);
    }
    useEffect(() => {
        ss();
    }, [, item])


    return (
        <div>
            <div>
                {Object.keys(premiumData ?? {}).map(oid => (
                    <div>
                        <div title={JSON.stringify(premiumData?.[oid]?.dates)}>Har varit premium: <span className="num">{premiumData?.[oid]?.dates?.length ?? 0}</span>  dagar.</div>
                    </div>
                ))}
            </div>

            <h3>
                Erbjudanden
            </h3>
            <div>
                Antal erbjudanden företaget haft under månaden: <span className="num">{Object.keys(offerData ?? {}).length}</span>.
            </div>
            <div>
                {Object.keys(offerData ?? {}).map(oid => (
                    <div key={oid} className="billing-offer">
                        <div>ErbjudandeId: {oid}</div>
                        <div>Har varit boostat: <span className="num">{offerData?.[oid]?.dates?.length ?? 0}</span> dagar.</div>
                        <div>
                            {JSON.stringify(offerData?.[oid]?.dates, null, 2)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}



const RawDataViewer = () => {
    return (
        <div>
            <div>
                visa detaljer:
            </div>
        </div>
    )
}
